import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getPresetColorPalettesV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/preset/v2/color-palettes`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getPresetColorPalettesV2 = () => {
  return resource.getPresetColorPalettesV2()
}

export default {
  initResource,
  getPresetColorPalettesV2,
}
